import * as React from 'react';

import {Button} from '../button/button';

import styles from './fetch-more-button.module.css';

type Props = {
    buttonText: string;
    onClick: () => void;
};

export function FetchMoreButton(props: Props) {
    return (
        <div className={styles['button-container']}>
            <Button variant='text-primary' onClick={props.onClick} isFullWidth={true}>
                {props.buttonText}
            </Button>
        </div>
    );
}
